import { queryClient } from '@/queries';
import { opoContactQueries } from './opo.query';
import { opoContactQueryKeys } from './opo.keys';

export const invalidateOpoContactListQueries = () => {
  return queryClient.invalidateQueries({ queryKey: opoContactQueryKeys.getList(), exact: false });
};

export const invalidateOpoContactItemQueries = (contactId: string) => {
  return queryClient.invalidateQueries({ queryKey: opoContactQueryKeys.getItem(contactId), exact: false });
};

export const getCachedOpoContactUserId = (contactId: string): string | undefined => {
  return queryClient.getQueryData(opoContactQueries.item(contactId).queryKey)?.userId ?? undefined;
};
